// 教研任务相关权限常量。
// 必须与后端 intl-erp-api/src/entities/EducationalResearchTask.js 中的常量严格一致。
//
// 面向（非全职）老师只有三个权限，均归入权限管理界面的「教研任务板块」分组：
//  1) 视频审核任务板块（仅看分配给自己的任务）
//  2) 教师评级板块（仅看分配给自己的任务）
//  3) 查看非全职老师教研工时（默认管理员以上）

export const EDUCATIONAL_RESEARCH_TASKS_ROUTE = 'educationalResearchTasks';

export const VIEW_OWN_VIDEO_REVIEW_PERMISSION = 'view-own-video-review';
export const VIEW_OWN_TEACHER_GRADE_PERMISSION = 'view-own-teacher-grade';
export const VIEW_PARTTIME_RESEARCH_HOURS_PERMISSION = 'view-parttime-working-hours';

// 「非全职老师教研工时」页按类型汇总的列（视频审核 + 教师评级）
export const RESEARCH_HOURS_CATEGORIES = ['抽查视频审核', '教师评级'];
